import intervalToDuration from '../intervalToDuration'
import formatDuration from 'date-fns/formatDuration'
import isBefore from 'date-fns/isBefore'


/**
 * returns a date string formatted hh:mm:ss or even DD:hh:mm:ss if you want to mess with people
 */
function toNumeric (withDays = false): string {

  const extract = [ 'hours', 'minutes', 'seconds' ]

  if (withDays) extract.unshift('days')

  const formatted = formatDuration(this.duration, { format: extract, zero: true, delimiter: ',' })
      .split(',')
      .map(value => value
        .substr(0, 2)
        .trimRight()
        .padStart(2, '0')
      )
      .join(':')

  return `${this.hasPassed && this.allowMinus ? '-' : ''}${formatted}`

}

/**
 * returns a date string formatted with days, hrs, mins, secs. But omitting any which are zero. ie. 5 mins 53 secs
 */
function toConciseString (): string {

  let formatString = ''

  const preFormatString =
    formatDuration(this.duration, {
      format: [ 'days', 'hours', 'minutes', 'seconds' ],
      zero: true,
      delimiter: ','
    }).replace('0 days ', '')
    .replace('second', 'sec')
    .replace('hour', 'hr')
    .replace('minute', 'min')

  let hasPositiveDatePart = false

  for(const datePart of preFormatString.split(',')) {

    if (datePart[0] === '0' && !hasPositiveDatePart) continue
    if (!hasPositiveDatePart) hasPositiveDatePart = true
    formatString += ` ${datePart}`

  }

  return `${this.hasPassed && this.allowMinus ? '-' : ''}${formatString.trimLeft()}`

}

/**
 * returns a date string formatted with days, hrs, mins, secs. ie. 0 hrs 5 mins 53 secs
 */
function toString (): string {

  let formatString = formatDuration(this.duration, {
    format: [ 'days', 'hours', 'minutes', 'seconds' ],
    zero: true
  })

  formatString = formatString
    .replace(/^0 days /i, '')
    .replace('second', 'sec')
    .replace('hour', 'hr')
    .replace('minute', 'min')

  return `${this.hasPassed && this.allowMinus ? '-' : ''}${formatString}`

}

interface DateDiffReturn {
  allowMinus?: boolean
  dateFrom?: string
  duration?: Duration
  toString?(): string
  toConciseString?(): string
  toNumeric?(withDays?: boolean): string
  hasPassed?: boolean
}

function getDateDiff (dateToCheck: string,
                      opts: { allowMinus?: boolean,
                      dateFrom?: string } = { allowMinus: false },
                      countDownFormat = ''): DateDiffReturn {

  if (typeof dateToCheck === 'undefined' || dateToCheck === '') return {}

  const start = new Date(dateToCheck)
  const end = opts.dateFrom ? new Date(opts.dateFrom) : new Date(Date.now())

  const hasPassed = isBefore(start, end)

  const duration = intervalToDuration(start, end)

  const res = {
    ...opts,
    duration,
    toString,
    toConciseString,
    toNumeric,
    hasPassed
  }

  return res

}

export default getDateDiff
